import { render } from "./Variety_shop_order.vue?vue&type=template&id=0f349296&scoped=true"
import script from "./Variety_shop_order.vue?vue&type=script&lang=js"
export * from "./Variety_shop_order.vue?vue&type=script&lang=js"

import "./Variety_shop_order.vue?vue&type=style&index=0&id=0f349296&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f349296"]])

export default __exports__